export * from '@hyphengroup/cms-components/utils/createMediaQuery';
